<app-signal-strength *ngIf="hasValue()" [value]="getValue()"></app-signal-strength>
